module.exports = __webpack_public_path__ + "static/media/van.2cd3222a.png";